import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

export const ArrowButton = ({
  direction = "left",
  disabled = false,
  onClick,
  className = "",
}: {
  direction?: "left" | "right"
  disabled?: boolean
  onClick?: () => void
  className?: string
}) => {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        "hidden h-[60px] w-[60px] items-center justify-center rounded-full bg-white text-2xl lg:flex",
        direction === "right" ? "" : "-scale-x-100",
        className
      )}
      style={{
        boxShadow: "0px 4px 16px 0px #00000040",
      }}
    >
      <ArrowIcon className={twMerge(disabled ? "text-nelo-dark-gray" : "")} />
    </button>
  )
}

const ArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      stroke="currentColor"
      d="m10.578 21.884 8.03-8.03.854-.854H.5v-2h18.961l-.852-.853-8.017-8.032L12 .707 23.293 12 11.999 23.294l-1.42-1.41Z"
    />
  </svg>
)
